import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloBoardVisibilityButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloBoardVisibilityButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloBoard","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloBoardVisibilityButton","document":TrelloBoardVisibilityButtonDocument}} as const;
export type TrelloBoardVisibilityButtonQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TrelloBoardVisibilityButtonQuery = (
  { __typename: 'Query' }
  & { trello: (
    { __typename: 'TrelloQueryApi' }
    & { board?: Types.Maybe<(
      { __typename: 'TrelloBoard' }
      & Pick<Types.TrelloBoard, 'id' | 'closed'>
      & { enterprise?: Types.Maybe<(
        { __typename: 'TrelloEnterprise' }
        & Pick<Types.TrelloEnterprise, 'id' | 'objectId'>
      )>, prefs: (
        { __typename: 'TrelloBoardPrefs' }
        & Pick<Types.TrelloBoardPrefs, 'permissionLevel'>
      ), workspace?: Types.Maybe<(
        { __typename: 'TrelloWorkspace' }
        & Pick<Types.TrelloWorkspace, 'id' | 'objectId'>
      )> }
    )> }
  ) }
);

/**
 * __useTrelloBoardVisibilityButtonQuery__
 *
 * To run a query within a React component, call `useTrelloBoardVisibilityButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloBoardVisibilityButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloBoardVisibilityButtonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrelloBoardVisibilityButtonQuery(
  baseOptions: TrelloQueryHookOptions<
    TrelloBoardVisibilityButtonQuery,
    TrelloBoardVisibilityButtonQueryVariables
  > &
    (
      | { variables: TrelloBoardVisibilityButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TrelloBoardVisibilityButtonDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TrelloBoardVisibilityButtonQuery,
    TrelloBoardVisibilityButtonQueryVariables
  >(TrelloBoardVisibilityButtonDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTrelloBoardVisibilityButtonLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TrelloBoardVisibilityButtonQuery,
    TrelloBoardVisibilityButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TrelloBoardVisibilityButtonQuery,
    TrelloBoardVisibilityButtonQueryVariables
  >(TrelloBoardVisibilityButtonDocument, options);
}
export function useTrelloBoardVisibilityButtonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TrelloBoardVisibilityButtonQuery,
        TrelloBoardVisibilityButtonQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TrelloBoardVisibilityButtonQuery,
    TrelloBoardVisibilityButtonQueryVariables
  >(TrelloBoardVisibilityButtonDocument, options);
}
export type TrelloBoardVisibilityButtonQueryHookResult = ReturnType<
  typeof useTrelloBoardVisibilityButtonQuery
>;
export type TrelloBoardVisibilityButtonLazyQueryHookResult = ReturnType<
  typeof useTrelloBoardVisibilityButtonLazyQuery
>;
export type TrelloBoardVisibilityButtonSuspenseQueryHookResult = ReturnType<
  typeof useTrelloBoardVisibilityButtonSuspenseQuery
>;
export type TrelloBoardVisibilityButtonQueryResult = Apollo.QueryResult<
  TrelloBoardVisibilityButtonQuery,
  TrelloBoardVisibilityButtonQueryVariables
>;
